<template>
  <div class="frameParent" v-if="lesson">
    <div class="frameGroup">
      <div class="frameWrapper">
        <div class="privatePilot2025Parent">
          <div class="text">
            Private Pilot 2025 |
            <b class="pilotQualifications">{{ lesson.name }}</b>
          </div>
        </div>
      </div>
      <div class="backWrapper">
        <img
          class="backIcon"
          alt=""
          src="/static/img/LeftChevron.svg"
          @click="navigateBack"
        />
      </div>
    </div>
    <div class="frameDiv">
      <div class="pilotQualificationsWrapper">
        <b class="text">{{ lesson.name }}</b>
      </div>
      <div class="textParent">
        <div class="text">Lesson Type</div>
        <div class="textWrapper">
          <div class="text">{{ lesson.lessonType.name }}</div>
        </div>
      </div>
      <div class="textParent">
        <div class="text">Lesson Objective</div>
        <div class="textWrapper">
          <div class="text">{{ lesson.description }}</div>
        </div>
      </div>
    </div>
    <div class="frameParent1">
      <div class="referenceMaterialWrapper">
        <b class="studentsWillUnderstand">Reference Material</b>
      </div>
      <div class="lessonStandardsParent">
        <div class="lessonMaterialsWrapper">
          <div class="learnFromHilo">Lesson Materials</div>
        </div>
        <div
          class="textWrapper"
          v-for="reference of lesson.lessonReferences"
          v-bind:key="reference.id"
        >
          <div class="text">{{ reference.description }}</div>
          <img
            style="cursor: not-allowed"
            class="arrowIcon"
            alt=""
            src="/static/img/grey-paper-airplane.svg"
          />
        </div>
      </div>
    </div>
    <div class="frameDiv">
      <div class="lessonElementsWrapper">
        <b class="studentsWillUnderstand">Lesson Elements</b>
      </div>
      <div
        class="frameParent4"
        v-for="element of lesson.lessonElements"
        v-bind:key="element.id"
      >
        <div class="text">
          Element {{ lesson.lessonElements.indexOf(element) + 1 }}
        </div>
        <div
          class="textWrapper"
          v-for="standard of element.elementStandards"
          v-bind:key="standard.id"
        >
          <div class="text">{{ standard.description }}</div>
          <img
            style="cursor: not-allowed"
            class="arrowIcon"
            alt=""
            src="/static/img/grey-paper-airplane.svg"
          />
        </div>
      </div>
    </div>
    <div class="frameParent1">
      <div class="referenceMaterialWrapper">
        <b class="studentsWillUnderstand">Lesson Standards</b>
      </div>
      <div class="lessonStandardsParent">
        <div class="lessonMaterialsWrapper">
          <div class="learnFromHilo">Lesson Standards</div>
        </div>
        <div
          class="textWrapper"
          v-for="standard of lesson.lessonStandards"
          v-bind:key="standard.id"
        >
          <div class="text">{{ standard.description }}</div>
          <img
            style="cursor: not-allowed"
            class="arrowIcon"
            alt=""
            src="/static/img/grey-paper-airplane.svg"
          />
        </div>
      </div>
    </div>
    <div class="frameParent1">
      <div class="referenceMaterialWrapper">
        <b class="studentsWillUnderstand">Complete Assignment</b>
      </div>
      <div class="lessonStandardsParent">
        <div class="text">Lesson Assignements</div>
        <div
          class="textWrapper"
          v-for="assignment of lesson.assignments"
          v-bind:key="assignment.id"
        >
          <div class="text">{{ assignment.name }}</div>
          <img
            v-if="
              !studentAssignments.some(
                (data) => data.assignmentId === assignment.id,
              )
            "
            class="arrowIcon"
            alt=""
            src="/static/img/grey-paper-airplane.svg"
            @click="goToAssignment(assignment.id, 'Take')"
          />
          <img
            v-else
            class="arrowIcon"
            alt=""
            src="/static/img/CompleteIcon.svg"
            @click="goToAssignment(assignment.id, 'Graded')"
          />
        </div>
      </div>
    </div>
    <!--        <div class="frameParent1">
          <div class="referenceMaterialWrapper">
              <b class="studentsWillUnderstand">Regulatory Requirements</b>
          </div>
          <div class="lessonStandardsParent">
              <div class="learnFromHilo">Regulations</div>
              <div class="far61105b1ApplicaableWrapper">
                  <div class="studentsWillUnderstand">FAR 61.105(b)(1) - Applicaable feberal aviation
                      regulations of this chapter that relate to private pilot priveleges, limitations, and flight
                      operations.</div>
              </div>
          </div>
      </div>
      <div class="frameDiv">
          <div class="lessonElementsWrapper">
              <b class="studentsWillUnderstand">Completion Status</b>
          </div>
          <div class="lessonTypeParent">
              <div class="notesWrapper">
                  <div class="learnFromHilo">Notes</div>
              </div>
              <div class="inputText">
                  <input type="text" placeholder="Notes..." v-model="form.notes">
              </div>
          </div>
          <div class="taughtByParent">
              <div class="pilotQualifications">Taught by</div>
              <div class="matthewBenesikParent">
                  <div class="learnFromHilo">Matthew Benesik</div>
                  <img class="vectorIcon1" alt="" src="Vector.svg" />
              </div>
              <div class="studentsWillAccuratelyIdentWrapper">
                  <div class="learnFromHilo">425635CFI</div>
              </div>
          </div>
          <div class="notesWrapper" :style="$global.dynamicCols(3)">
              <div class="attendance">Attendance</div>
              <div class="inputText">
                  <HiloSelect :options="[]" v-model="selectedAttendance" placeholder="Select all..." style="width: 100%; height: 47px" :searchable="true" />
              </div>
              <div class="inputText">
                  <input type="date">
              </div>
          </div>
          <div class="notesWrapper" :style="$global.dynamicCols(3)">
              <div class="studentsWillUnderstand">Signing Instructor</div>
              <div class="clickToSignWrapper" @click="signatureModalVisible = true">
                  <div class="learnFromHilo">Click to Sign</div>
              </div>
              <div class="wrapper">
                  <div class="learnFromHilo">{{ form.signatureDate ? $global.formatDate(form.signatureDate) : '' }}</div>
              </div>
          </div>

          <SignatureModal
              :isVisible="signatureModalVisible"
              :firstName="$store.getUser.firstName"
              :lastName="$store.getUser.lastName"
              @save="handleSignatureSave"
              @close="signatureModalVisible = false"
          />
      </div>-->
  </div>
</template>
<script>
import { useLoginStore } from "../../../../stores/loginStore";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import SignatureModal from "@/components/HiloComponents/SignatureModal.vue";
import LessonsAPIService from "../../../../servicehandlers/LessonsAPIService";
import AssignmentsAPIService from "../../../../servicehandlers/AssignmentsAPIService";

const lessonAPIService = new LessonsAPIService();
const assignmentAPIService = new AssignmentsAPIService();
export default {
  components: {
    //HiloSelect,
    //SignatureModal,
  },
  name: "Frame",
  data() {
    return {
      lessonId: null,
      lesson: null,
      student: null,
      studentAssignments: [],
    };
  },
  async mounted() {
    this.lessonId = this.$route.query.lessonId;
    this.student = this.useLoginStore().getUser;
    await this.getStudentAssignments();
    await this.getLesson();
  },
  methods: {
    useLoginStore,
    getLesson() {
      if (this.lessonId) {
        return lessonAPIService
          .getLessonById(this.lessonId)
          .then((response) => {
            this.lesson = response;
          });
      }
    },
    getStudentAssignments() {
      return assignmentAPIService
        .getStudentAssignmentsForStudent(this.student.id, this.$router)
        .then((response) => {
          this.studentAssignments = response;
        });
    },
    handleSignatureSave(signature) {
      this.form.signature = signature;
      this.form.signatureDate = new Date();
    },
    navigateBack() {
      this.$router.go(-1);
    },
    goToAssignment(assignmentId, type) {
      this.$router.push({
        name: type + " Assignment",
        query: {
          assignmentId,
        },
      });
    },
  },
};
</script>
<style scoped>
.frameChild {
  align-self: stretch;
  width: 1px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}

.pilotQualifications {
  position: relative;
  color: #404040;
}

.privatePilot2025Parent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.frameWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  z-index: 0;
}

.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.backWrapper {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0px;
  /* background-color: #f6f6f6; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}

.frameGroup {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  position: relative;
  gap: 20px;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}

.vectorIcon {
  width: 24px;
  position: relative;
  height: 23px;
}

.text {
  position: relative;
}

.vectorParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.learnNowWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px;
  font-size: 15px;
  color: #d701ff;
}

.frameContainer {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background: linear-gradient(90deg, #2200ff, #ea00ff);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
}

.pilotQualificationsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 40px;
}

.inputText {
  align-self: stretch;
  border-radius: 10px;
  /* background-color: rgba(255, 255, 255, 0.05); */
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* padding: 0px 20px; */
  color: #707070;
  width: 100%;
}
.inputText input {
  background-color: #fff;
}

.textParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.studentsWillUnderstand {
  flex: 1;
  position: relative;
}

.textWrapper {
  position: relative;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 15px;
  color: rgba(64, 64, 64, 0.75);
}

.frameDiv {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
  font-size: 15px;
}

.referenceMaterialWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.lessonMaterialsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 5px;
}

.arrowIcon {
  width: 30px;
  height: 20px;
  position: absolute;
  right: 0;
  cursor: pointer;
}

.far61103Parent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
}

.frameParent1 {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
}

.lessonElementsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.ageEducationalPrerequisites {
  width: 338px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.ageEducationalPrerequisitesWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
  padding: 20px;
}

.element1Parent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.studentsWillAccurately {
  width: 330px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.studentsWillAccuratelyIdentWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
}

.frameParent4 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.studentsShouldOutlineTheGeWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}

.lessonStandardsParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
}

.pilotQualificationsParent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  color: rgba(64, 64, 64, 0.75);
}

.far61105b1ApplicaableWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 20px;
  color: rgba(64, 64, 64, 0.75);
}

.notesWrapper {
  display: grid;
  align-items: center;
  gap: 20px;
  justify-content: start;
  align-self: stretch;
}

.notesContainer {
  /* align-self: stretch;
    background-color: rgba(255, 255, 255, 0.05);
    box-sizing: border-box;
    height: 47px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 15px 20px;
    color: rgba(64, 64, 64, 0.5); */
  width: 100%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.vectorIcon1 {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}

.matthewBenesikParent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

.taughtByParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  color: rgba(64, 64, 64, 0.75);
}

.attendance {
  flex: 1;
  position: relative;
  color: #404040;
}

.selectAllParent {
  flex: 0.8226;
  border-radius: 10px;
  /* background-color: rgba(255, 255, 255, 0.05); */
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
}

.attendanceParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: rgba(64, 64, 64, 0.5);
}

.clickToSignWrapper {
  flex: 0.831;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.15);
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  box-sizing: border-box;
  transition: 0.2s ease-in-out;
  cursor: pointer;
}

.clickToSignWrapper:hover {
  opacity: 0.8;
}

.wrapper {
  flex: 0.8226;
  border-radius: 10px;
  /* background-color: rgba(255, 255, 255, 0.05); */
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  color: rgba(64, 64, 64, 0.5);
}

.signingInstructorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.saveLessonWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.saveLessonWrapper:hover {
  opacity: 0.8;
}

.frameWrapper1 {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 18px;
  color: #fff;
}

.frameChild4 {
  width: 100px;
  position: relative;
  /* background-color: #f6f6f6; */
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
}

.frameParent {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 25px 0px 0px;
  box-sizing: border-box;
  gap: 25px;
  text-align: left;
  font-size: 22px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
